<mat-card class="buy-sell-plan-details" role="region" [attr.aria-label]="'BuySellPlanDetails' | translate: {Default: 'Buy/Sell Plan Details'}">
    <mat-card-title>
        <h3 id="buy-sell-plan-details-title" appLocalizationPopupDirective localizationCode="BuySellPlanDetails">
            {{ 'BuySellPlanDetails' | translate: {Default: "Buy/Sell Plan Details"} }}
        </h3>
    </mat-card-title>
    
    <mat-card-content>
        <dl class="detail-list" aria-labelledby="buy-sell-plan-details-title">
            <div class="detail-row">
                <dt class="label">{{getFieldName('tbl_BsPlanName')}}</dt>
                <dd class="value">{{buySellPlan?.name}}</dd>
            </div>
            <div class="detail-row">
                <dt class="label">{{getFieldName('tbl_BsPlanDescription')}}</dt>
                <dd class="value">{{buySellPlan?.description}}</dd>
            </div>
            <div class="detail-row">
                <dt class="label">{{getFieldName('tbl_BsPlanTimeoffType')}}</dt>
                <dd class="value">{{buySellPlan?.timeOffType?.name}}</dd>
            </div>
        </dl>
    </mat-card-content>
</mat-card>